import Replace from './Replace';

export default {
  __init__: [ 'replace' ],
  replace: [ 'type', Replace ]
};